import React from "react";

import { CDN_URL } from "../../constant";
import { Helmet } from "react-helmet";

export default function AuthLayout({
  title,
  subtitle,
  form,
  titleStyle = {},
  headTitle = "",
  extraContent = null,
}) {
  return (
    <div className="nk-main" style={{ background: "white" }}>
      <div className="nk-wrap nk-wrap-nosidebar">
        <div className="nk-content ">
          <div className="nk-split nk-split-page nk-split-lg">
            <div className="nk-split-content nk-block-area nk-block-area-column nk-auth-container w-lg-45">
              <div className="absolute-top-right d-lg-none p-3 p-sm-5">
                <a
                  href="#"
                  className="toggle btn btn-white btn-icon btn-light"
                  data-target="athPromo"
                >
                  <em className="icon ni ni-info"></em>
                </a>
              </div>
              <Helmet>
                <title>{headTitle}</title>
              </Helmet>
              <div
                className="nk-block nk-block-middle nk-auth-body"
                style={{
                  width: "100%",
                  maxWidth: "420px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  background: "#fff",
                  borderRadius: "8px",
                  padding: "0.5rem",
                }}
              >
                <div
                  className="brand-logo pb-5"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <a href="/demo2/index.html" className="logo-link">
                    <img
                      className="logo-light logo-img logo-img-lg"
                      src={CDN_URL + "auth-ahrvo-logo.png"}
                      alt="logo"
                    />
                    <img
                      className="logo-dark logo-img logo-img-lg"
                      src={CDN_URL + "auth-ahrvo-logo.png"}
                      alt="logo-dark"
                    />
                  </a>
                </div>
                <div className="nk-block-head">
                  <div className="nk-block-head-content">
                    <h5 className="nk-block-title" style={titleStyle}>
                      {title}
                    </h5>
                    <div className="nk-block-des">
                      <p>{subtitle}</p>
                    </div>
                  </div>
                </div>
                {form}
                {extraContent && extraContent}
              </div>
              <div
                className="nk-block nk-auth-footer"
                style={{
                  width: "100%",
                  maxWidth: "420px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  background: "#fff",
                  borderRadius: "8px",
                }}
              >
                <div className="nk-block-between">
                  <ul className="nav nav-sm">
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        target="_blank"
                        href="https://ahrvo.com/terms-of-service/"
                      >
                        Terms and Conditions
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        href="https://ahrvo.com/data-privacy-policy/"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="mt-3">
                  <p>&copy;2024 AHRVO COMPLY. ALL RIGHTS RESERVED.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
